import Picker from 'emoji-picker-react';
import { useTheme } from '../../context/ThemeContext';
import './appEmojiPicker.css';

// Keep the installed picker's (event, emojiData) contract and caller-owned
// placement/dismissal. Only appearance and the app theme are shared here.
export default function AppEmojiPicker({ theme, pickerStyle, ...props }) {
  const { darkTheme } = useTheme();
  const resolvedTheme = theme || (darkTheme ? 'dark' : 'light');
  return <div className="app-emoji-picker" data-theme={resolvedTheme}
    style={pickerStyle?.width ? { width: pickerStyle.width } : undefined}>
    <Picker searchPlaceholder="Search emoji" {...props} pickerStyle={{ ...pickerStyle, width: '100%' }} />
  </div>;
}
